'use client'

import { useState, type ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Process-shared QueryClient for the protected app. Defaults err on the side
// of "trust the cache" — realtime channels are responsible for pushing
// invalidations into the cache, so polling/refetch is unnecessary.
const defaults = {
    queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1
    }
}

export function ReactQueryProvider({ children }: { children: ReactNode }) {
    const [client] = useState(() => new QueryClient({ defaultOptions: defaults }))
    return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
